import {
  IGenericRequestParametersTranslator,
  INamedEntityLabels,
  IPaginationParametersTranslator,
  PropertyTranslator,
} from "./GenericTranslator";
import {
  GenericEntityOrderBy,
  EntityConstants,
  IEntityMinimalModel,
  IGenericRequestParameters,
  IModelWithStringId,
  INamedEntity,
  IPaginationParameters,
  NamedEntityOrderBy,
} from "./GenericTypes";

export const methodsConstants: EntityConstants<Method, MethodFilters> = {
  resource: "methods",
  frontendIndexRoute: "methods",
  entitySingular: "method",
  entityPlural: "methods",
  icon: "microscope",
};

export interface Methods {
  [id: string]: {
    id: string;
    name: string;
    fullName: string;
    from: string[] | null;
    description: string | null;
    dataFormats: IEntityMinimalModel<string>[] | null;
  };
}

// New endpoints
export interface Method extends IModelWithStringId, INamedEntity {
  fullName: string;
  from: IEntityMinimalModel<string>[];
  parent: IEntityMinimalModel<string>;
  description: string;
  dataFormats: IEntityMinimalModel<string>[];
}

export const MethodFieldLabels: PropertyTranslator<Method> = {
  id: "Method ID",
  ...INamedEntityLabels,
  description: "Description",
  fullName: "Full name",
  from: "From",
  parent: "Parent",
  dataFormats: "Data formats",
} as const;

export interface MethodSuggestions extends IEntityMinimalModel<Method["id"]> {}

export interface MethodFilters extends IGenericRequestParameters<Method, MethodSortingOptions>, IPaginationParameters {
  dataFormatIds?: string[] | null;
}

export const MethodFiltersTranslator: PropertyTranslator<MethodFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  dataFormatIds: "Format IDs",
} as const;

export const MethodSortingOptionsConsts = [...GenericEntityOrderBy, ...NamedEntityOrderBy, "FULL_NAME"] as const;
export type MethodSortingOptions = (typeof MethodSortingOptionsConsts)[number];
